import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import {  Col, Container, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { ThreeDotSpinner } from '../../common/loader/loader';
import contactusService from '../../service/contactus';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";

export const ContactusManagemet = () => {

  const [Loader, setLoader] = useState(false)
  const [contactus, setContactus] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })
  const [showFullMessage, setShowFullMessage] = useState(false);
  const toggleMessage = () => setShowFullMessage(prev => !prev);

  useEffect(() => {
    fetchContactus()
  }, [pagination.pageNumber])

  const fetchContactus = async () => {
    setLoader(true);
    const params = {page: pagination.pageNumber - 1, size: pagination.pageSize}
    const response = await contactusService.get(params);
    if (response.status == 200) {
      setLoader(false);
      setContactus(response.data.data.contactus)
      setPagination({
        ...pagination,
        totalCount: response.data.data.count
      })
    }
  }

  const handleStatusChange = async (e, contact) => {
  const newStatus = e.target.value;

  const willUpdate = await swal({
    title: "Are you sure?",
    text: `Do you really want to update status?`,
    icon: "warning",
    buttons: ["Cancel", "Update"],
    dangerMode: true,
  });

  if (willUpdate) {
    setLoader(true);
    try {
      const params = { id: contact._id, status: newStatus };
      const res = await contactusService.put(params);

      if (res.status === 200) {
        toast.success(res.data.message);
        await fetchContactus();
      }
    } catch (error) {
      toast.error("Failed to update status");
    } finally {
      setLoader(false);
    }
  }
};


  const ContactusStatus = {
    PENDING:"Pending",
    ACKNOWLEDGED : "Acknowledged",
    IN_PROGRESS : "In Progress",
    CLOSED : "Closed"
}

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  const renderToggleTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      enable/disable
    </Tooltip>
  );

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Help & Support</h2>
                  </div>

                </div>
              </Col>
            </Row>

            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>           
                        <th>Name</th>               
                        <th>Phone</th>
                        <th>Transaction ID</th>
                        <th>Message</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody> 
                      { contactus.length > 0 &&
                        contactus.map((contact, index) => (
                          <tr key={index}>
                            <td>{moment(contact?.createdAt).format('DD-MM-YYYY')}</td>
                            <td> 
                              <a
                                href={`/users/${contact?.userId?._id}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                  {contact?.userId.fullName}
                                </div>
                              </a>
                            </td>
                            <td>{contact?.userId.phone}</td>
                            <td>{contact?.transactionId}</td>
                            <td  className="wrap-text">
                            <div
                              style={{
                                display: '-webkit-box',
                                WebkitLineClamp: showFullMessage ? 'none' : 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {contact?.message}
                            </div>
                            {contact?.message && contact.message.length > 100 && (
                              <span
                                onClick={toggleMessage}
                                style={{ color: 'blue', cursor: 'pointer', fontSize: '1.0em' }}
                              >
                                {showFullMessage ? 'Show less' : 'Show more'}
                              </span>
                            )}
                          </td> 
                          <td>
                            <div className='filter-section'>                             
                              <select className='form-select' value={contact?.status || ''}  onChange={(e) => handleStatusChange(e, contact)}>
                                {
                                  Object.entries(ContactusStatus).map(([key, label]) => (
                                    <option key={key} value={key}>{label}</option>
                                  ))
                                }
                              </select>
                            </div>
                          </td>                                       

                          </tr>
                        ))
                      }

                      {
                        pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  } 
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
